<template>
  <div class="gf_plan-item">
    <div
      class="gf_plan-item__section"
      :class="{ is_recommended: isRecommended, is_current_plan: isCurrentPlan }"
    >
      <div class="gf_plan-item__section--intro">
        <div class="gf_price-intro--label" :class="{'starter-disable': planInStarter}" v-html="$t(featureDescription)" v-if="planInStarter"></div>
        <div class="gf_price-intro--label" :class="{'starter-disable': planInStarter}" v-html="$t(extraData.feature.description)" v-else-if="hasCurrentFeatureCondition"></div>
        <div class="gf_price-intro--label" :class="{'starter-disable': planInStarter}" v-html="$t(prepareFeatureDescription)" v-else></div>
        <div class="gf_price-intro__list" :class="{'starter-disable': planInStarter}">
          <Feature
            v-for="feature in prepareFeatures"
            :text="feature.text"
            :active="feature.defaultActive"
            :is-new="feature.isNew"
            :tooltip="feature.tooltip"
            :label="feature.label || undefined"
            :planStarter="planInStarter"
            :key="feature.key" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import promotion from "@/modules/Pricing/mixins/promotion";
import plan from "@/modules/Pricing/mixins/plan";
import planItem from "@/modules/Pricing/mixins/planItem";
import { PLAN_NO } from "@/contants/plan";

export default {
  name: "RowIntroItem",
  mixins: [promotion(), plan(), planItem()],
  computed: {
    prepareFeatures() {
      if (this.isDevelopmentStore) {
        if (this.planDevelopmentStore === PLAN_NO.DEVELOPMENT && this.planNo === PLAN_NO.DEVELOPMENT_STORE) {
          return this.oldPlan?.features
        }
        return this.features
      }
      
      if (this.plan === PLAN_NO.PROFESSIONAL && this.planNo === PLAN_NO.BUILD) {
        return this.oldPlan?.features
      }

      if (this.plan === PLAN_NO.ADVANCED && this.planNo === PLAN_NO.OPTIMIZE) {
        return this.oldPlan?.features
      }

      return this.features
    }
  }
};
</script>
